import { useWatch } from 'react-hook-form'
import { useMemo } from 'react'
import { ProductValues } from '../types'

export const useInStock = () => {
  const [variant, links] = useWatch<ProductValues>({
    name: ['variant', 'links'],
  }) as [ProductValues['variant'], ProductValues['links']]

  return useMemo(() => {
    const isInStock =
      (variant?.in_stock && links.every(({ variant }) => variant?.in_stock)) ??
      false

    const isLowStock =
      isInStock &&
      (variant?.low_in_stock ||
        links.some(({ variant }) => variant?.low_in_stock))

    return { isInStock, isLowStock }
  }, [variant, links])
}
